import { Directive, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { tap } from 'rxjs';
import { ActiveUserService } from '../services/common/active-user.service';
import { ClinicalNoteService } from '../services/common/clinical-note.service';
import { ScopesEnum } from '../types/enum/viewMode';
import { Scopes } from '../types/util';

@Directive({
  selector: '[jargonViewModeForm]'
})
export class ViewModeFormDirective implements OnInit {

  @Input('formGroup') formGroup?: FormGroup;
  @Input('formControlName') formControlName?: string;
  @Input('formControl') formControl?: FormControl;

  private scope!: Scopes;
  private activeScopes: Scopes[];

  constructor(
    private activeUserService: ActiveUserService,
    private clinicalNoteService: ClinicalNoteService,
    @Host() @SkipSelf() @Optional() private parentControl: ControlContainer
  ) {
    this.activeScopes = this.activeUserService.scopes;
  }

  @Input('jargonViewModeForm') set allowedMode(scope: Scopes) {
    this.scope = scope;
  }

  ngOnInit() {
    this.toggleControlState();
    this.clinicalNoteService.config.pipe(
      tap(() => this.toggleControlState())
    ).subscribe();
  }

  toggleControlState() {
    let state = this.activeScopes.includes(this.scope);
    if (
      ([
        ScopesEnum.SCOPE_NOTES_WRITE,
        ScopesEnum.SCOPE_NOTES_FINALIZE,
        ScopesEnum.SCOPE_REVIEW_WRITE,
        ScopesEnum.SCOPE_BUILDERS_WRITE
      ] as Scopes[]).includes(this.scope)
      && this.clinicalNoteService.isReadOnly
    ) {
      state = false;
    }
    this.handleFormGroup(state);
    this.handleFormControl(state);
  }

  handleFormGroup(state: boolean) {
    if (state)
      this.formGroup?.enable();
    else
      this.formGroup?.disable();
  }

  handleFormControl(state: boolean) {
    if (this.formControl) {
      if (state)
        this.formControl.enable();
      else
        this.formControl.disable();
    }
    if (this.formControlName) {
      if (state)
        this.parentControl.control?.get(this.formControlName)?.enable();
      else
        this.parentControl.control?.get(this.formControlName)?.disable();
    }

  }
}
